import { create } from 'zustand';

/**
 * Global application store
 */
const useAppStore = create((set, get) => ({
  // Agent status
  agentStatus: {
    status: 'unknown',
    isRunning: false,
    uptime: 0,
    lastSync: null,
  },

  // Notifications (persistent, must be manually dismissed)
  notifications: [],

  // Active tasks (syncing, processing, etc.)
  activeTasks: [],

  // UI state
  sidebarOpen: true,
  theme: 'light',

  // Actions
  setAgentStatus: (status) => set({ agentStatus: status }),

  addNotification: (notification) => {
    const id = Date.now().toString();
    set((state) => ({
      notifications: [
        {
          id,
          type: 'info',
          ...notification,
          timestamp: new Date(),
        },
        ...state.notifications,
      ],
    }));

    return id;
  },

  removeNotification: (id) => set((state) => ({
    notifications: state.notifications.filter((n) => n.id !== id),
  })),

  clearAllNotifications: () => set({ notifications: [] }),

  // Task management
  addTask: (task) => {
    const id = Date.now().toString();
    set((state) => ({
      activeTasks: [
        ...state.activeTasks,
        {
          id,
          status: 'running',
          ...task,
          startedAt: new Date(),
        },
      ],
    }));
    return id;
  },

  updateTask: (id, updates) => set((state) => ({
    activeTasks: state.activeTasks.map((task) =>
      task.id === id ? { ...task, ...updates } : task
    ),
  })),

  removeTask: (id) => set((state) => ({
    activeTasks: state.activeTasks.filter((task) => task.id !== id),
  })),

  toggleSidebar: () => set((state) => ({
    sidebarOpen: !state.sidebarOpen,
  })),

  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  setTheme: (theme) => {
    set({ theme });
    // Apply theme to document
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  },

  initTheme: () => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    get().setTheme(savedTheme);
  },
}));

export default useAppStore;
